var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 12.004,
    x2: 12.004,
    y1: 1.998,
    y2: 22.003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "#14f9ff",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 1,
    stopColor: "#b21cd8",
    offset: 1
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M21.56 10.74 20.2 9.16c-.26-.3-.47-.86-.47-1.26V6.2c0-1.06-.87-1.93-1.93-1.93h-1.7c-.39 0-.96-.21-1.26-.47l-1.58-1.36c-.69-.59-1.82-.59-2.52 0L9.17 3.81c-.3.25-.87.46-1.26.46H6.18c-1.06 0-1.93.87-1.93 1.93v1.71c0 .39-.21.95-.46 1.25l-1.35 1.59c-.58.69-.58 1.81 0 2.5l1.35 1.59c.25.3.46.86.46 1.25v1.71c0 1.06.87 1.93 1.93 1.93h1.73c.39 0 .96.21 1.26.47l1.58 1.36c.69.59 1.82.59 2.52 0l1.58-1.36c.3-.26.86-.47 1.26-.47h1.7c1.06 0 1.93-.87 1.93-1.93v-1.7c0-.39.21-.96.47-1.26l1.36-1.58c.58-.69.58-1.83-.01-2.52zm-5.4-.63-4.83 4.83a.75.75 0 0 1-1.06 0l-2.42-2.42c-.29-.29-.29-.77 0-1.06s.77-.29 1.06 0l1.89 1.89 4.3-4.3c.29-.29.77-.29 1.06 0s.29.77 0 1.06z",
    "data-original": "url(#a)",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVery);
export default __webpack_public_path__ + "static/media/very.4af0b1bcc6f378ccf87303c1fc450587.svg";
export { ForwardRef as ReactComponent };